export default __webpack_public_path__ + "9e064c391e3379d37f99ef3df52a55cd.svg";